import { useCallback } from "react";
import { INotification } from "../../store/types";
import { NotificationHandlerType } from "./use-click-handler";
import { useNavigate } from "hooks/shared-hooks/use-navigate";

export function useDataroomHook(): NotificationHandlerType {
  const navigate = useNavigate();

  return useCallback(async ({ components }: INotification) => {
    if (components.dataroom_id) {
      navigate({
        route: "dataRoom",
        params: {
          room_id: components.dataroom_id as number
        },
        setQueriesMethod: "replace"
      });
    }
  }, []);
}
